import React from "react";
import ReactApexChart from "react-apexcharts";

const ReservationChart = ({ data }) => {
  let series1 = data?.map((item) => item.count);
  const xCol = data?.map((item) => item._id);

  const state = {
    series: [
      {
        name: "series1",
        data: series1,
      },
      // {
      //   name: "series2",
      //   data: [
      //     350, 350, 420, 370, 500, 400, 550, 420, 600, 450, 550, 400, 650,
      //   ],
      // },
    ],
    options: {
      chart: {
        height: 400,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      colors: ["#F6953B", "#4BDB94", "#52c077"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 6,
        curve: "smooth",
      },
      legend: {
        show: false,
      },
      grid: {
        borderColor: "#EBEBEB",
        strokeDashArray: 6,
      },
      markers: {
        strokeWidth: 6,
        hover: {
          size: 15,
        },
      },
      yaxis: {
        labels: {
          offsetX: -12,
          style: {
            colors: "#787878",
            fontSize: "13px",
            fontFamily: "Poppins",
            fontWeight: 400,
          },
        },
      },
      xaxis: {
        categories: xCol,
        labels: {
          style: {
            colors: "#787878",
            fontSize: "13px",
            fontFamily: "Poppins",
            fontWeight: 400,
          },
        },
      },
      fill: {
        type: "solid",
        opacity: 0.1,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="area"
        height={400}
      />
    </div>
  );
};

export default ReservationChart;
